import { afterSubscribeCleanup } from './afterSubscribeCleanup'
import { globals } from '@/src/globals'
import axios from 'axios/dist/axios'

export const axios_ecoMailSubscribeHeader = () => {
  const ecoMailForm = document.querySelector('.js-ecoMailSubsribe-header-form') as HTMLFormElement
  const ecoMailInput = document.querySelector('.js-ecoMailSubsribe-header-input') as HTMLInputElement
  const ecoMailSubmit = document.querySelector('.js-ecoMailSubsribe-header-submit') as HTMLElement
  const ecoMailError = document.querySelector('.js-ecoMailSubsribe-header-error') as HTMLElement

  if (!ecoMailForm || !ecoMailInput || !ecoMailSubmit) {
    return
  }

  // Validate email function
  const validateEmail = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  const checkEmail = () => {
    const emailInput = ecoMailInput.value

    if (validateEmail(emailInput)) {
      return true
    }
    else {
      return false
    }
  }

  // Listen to clicks on the submit button
  ecoMailSubmit.addEventListener('click', (e) => {
    e.preventDefault()
    if (checkEmail()) {
      const emailInput = ecoMailInput.value
      subscribeEmail(emailInput)
      ecoMailError.classList.add('hidden')
    }
    else {
      ecoMailError.classList.remove('hidden')
    }
  })

  // Listen to clicks on the submit button
  ecoMailForm.addEventListener('submit', (e) => {
    e.preventDefault()
    if (checkEmail()) {
      const emailInput = ecoMailInput.value
      subscribeEmail(emailInput)
      ecoMailError.classList.add('hidden')
    }
    else {
      ecoMailError.classList.remove('hidden')
    }
  })

  const subscribeEmail = (email) => {
    const requestURL = `${globals.externalInput.wpSpecalAjaxURL}?action=ecoMailAddSubscriber&email=${email}`

    axios.get(requestURL)
      .then(response => {
        afterSubscribeCleanup()
      })
      .catch(e => {
        console.log(e)
      })
  }
}
